<template>
  <div class="banner">
    <el-carousel v-if="carousel.if" height="30px" direction="vertical" autoplay style="width: 400px" :interval="time" indicator-position="none">
      <el-carousel-item v-for="(item,index) in banners ? banners[$store.getters.permission_routesType.toLowerCase()] : []" :key="item.message">
        <el-tooltip class="item" effect="light" content="Top Left 提示文字" placement="bottom">
          <div slot="content"><span :style="item.type === 'warn'?'color: rgb(237 143 143);':''"><i :class="{'el-icon-info': item.type === 'info', 'el-icon-warning': item.type === 'warn'}" style="margin-right:5px" /><NodeItem :key="index" :node="getMessage(item.message)" /></span></div>
          <span class="overflow-hidden-1" :style="item.type === 'warn'?'color: rgb(237 143 143);':''"><i :class="{'el-icon-info': item.type === 'info', 'el-icon-warning': item.type === 'warn'}" style="margin-right:5px" />
            <NodeItem :key="index" :node="getMessage(item.message)" />
          </span>
        </el-tooltip>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getBanners } from '@/api/banners'
import NodeItem from '@/views/components/NodeItem'
export default {
  name: 'Banner',
  components: {
    NodeItem
  },
  data() {
    return {
      banners: [],
      time: 20000,
      carousel: {
        if: true
      },
      messageType: [
        { label: '文字链接', message: '$url{文字：链接}', type: '$url', reg: /\$url\{[\S]{1,}\：[\S]{1,}\}/g,
          formatter: (herf, label) => {
            return <a style='color:#20a0ff' href={herf} target='_blank'>{label}</a>
          }
        }
      ]
    }
  },
  watch: {
    '$store.getters.permission_routesType': {
      deep: true,
      handler(banners) {
        this.carousel.if = false
        this.$nextTick(() => {
          this.carousel.if = true
        })
      }
    }
  },
  created() {
    this.setBanners()
  },
  methods: {
    setBanners() {
      this.getBanners()
      this.$store.dispatch('timer/init', { name: 'unBannerTimer', fn: this.getBanners, time: 200000 }).catch(reason => {
        console.log(reason)
      })
    },
    getMessage(message) {
      // 获取链接
      this.messageType.forEach(element => {
        let url = message.match(element.reg)
        if (url) {
          url = url[0]
          message = message.replace(element.reg, element.type)
          const index = message.indexOf(element.type)
          url = url.replace(element.type + '{', '')
          url = url.replace('}', '')
          url = url.split('：')
          if (url.length === 2) {
            message = <span>{message.substring(0, index)}{element.formatter(url[1], url[0])}{message.substring(index + 4)}</span>
          }
        }
      })

      return <span>{message}</span>
    },
    getBanners() {
      getBanners().then(res => {
        this.banners = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.banner{
  display: inline-block;
  height: 50px;
  padding: 10px;
  line-height: 30px;
  margin-left: 32px;
  color: #888;
}
@media  (max-width: 1000px){
  .banner{
    display: none;
  }
}

</style>
